import { networkService } from "services/networkService";
import {
  METHOD_ORACLE_VERSION_LIST,
  METHOD_ORACLE_VERSION_CREATE,
  METHOD_ORACLE_VERSION_UPDATE,
  METHOD_ORACLE_VERSION_DELETE,
  METHOD_ORACLE_VERSION_DETAIL,
} from "constants/admin/masters/hdlm-rac";
class OracleVersionService {
  getAll = (data) => {
    return networkService
      .post(METHOD_ORACLE_VERSION_LIST, data)
      .then((response) => response.data);
  };
  getDetail = (id) => {
    const updatedMethodName = METHOD_ORACLE_VERSION_DETAIL.replace("{ID}", id);
    return networkService
      .get(updatedMethodName)
      .then((response) => response.data);
  };
  create = (data) => {
    return networkService
      .post(METHOD_ORACLE_VERSION_CREATE, data)
      .then((response) => response.data);
  };
  update = (data, id) => {
    const updatedMethodName = METHOD_ORACLE_VERSION_UPDATE.replace("{ID}", id);
    return networkService
      .post(updatedMethodName, data)
      .then((response) => response.data);
  };
  delete = (id,is_delete=false) => {
    const updatedMethodName = METHOD_ORACLE_VERSION_DELETE.replace("{ID}", id);
    return networkService
      .delete(updatedMethodName,{ data: { is_delete }})
      .then((response) => response.data);
  };
}
export default OracleVersionService;
